
import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import FilterBarNPSType from './FilterBarNPSType.vue'
import FilterBarQuestionType from './FilterBarQuestionType.vue'
import FilterBarTime from './FilterBarTime.vue'
import FilterBarActive from './FilterBarActive.vue'
import FilterBarSecondary from './FilterBarSecondary.vue'
import FilterBarLoader from './FilterBarLoader.vue'
import FilterBarDownload from './FilterBarDownload.vue'
import FilterBarTVMenu from './FilterBarTVMenu.vue'
import FilterAndDigestEditor from './FilterAndDigestEditor.vue'
import GeneralNPSReportDownload from './GeneralNPSReportDownload.vue'
import Toasts from './Toasts.vue'
import { getBaseUserRoles } from '@/api/appstore/personal-scorecard'
import { IUserType } from '@/entities/usertype'

@Component<FilterBar>({
    components: {
        FilterBarTime,
        FilterBarNPSType,
        FilterBarQuestionType,
        FilterBarActive,
        FilterBarSecondary,
        FilterBarLoader,
        FilterBarDownload,
        FilterBarTVMenu,
        FilterAndDigestEditor,
        GeneralNPSReportDownload,
        Toasts,
    },
})
export default class FilterBar extends Vue {
    public showTV = false
    public showButtons = true
    public enabledLeadWithAnyQuestion = false
    public userRoles: IUserType[] = []

    @Prop({ type: Boolean, default: true })
    public shouldReloadOnChange!: boolean
    @Prop({ type: Boolean, default: false })
    public enabledExecutiveReporting!: boolean
    @Prop({ type: Boolean, default: false })
    public enabledGeneralReporting!: boolean
    @Prop({ type: Boolean, default: false }) public isInMobile!: boolean
    @Prop({ type: String, default: null }) public questionType!: string
    @Prop({ type: Array, default: () => [] }) public permissions!: string[]

    @Action public getFilters
    @Action public getScorecardTopics
    @Action public getDigests
    @Action public statusClearToasts
    @Action public setAppBaseUrl
    @Action public statusRemoveToast

    @Getter public statusToasts
    @Getter public filterLastPatch
    @Getter public details

    /**
     * This just reloads the page after applying a patch, it's a short-term solution
     * until the entire dashboard and responses pages are in Vue.
     * Note that we remove the url query, relying only on the filter stored in the db.
     */
    @Watch('filterLastPatch')
    public onFilterLastPatchChanged(time: number) {
        // for new dashboard, we don't need to reload, it's listening to the events and updating the data on page
        if (!this.shouldReloadOnChange) {
            return
        }
        // otherwise support legacy
        const currentUrl = [
            location.protocol,
            '//',
            location.host,
            '/',
            location.pathname.split('/').filter((n) => n !== '')[0],
            // Only keep first part of path, e.g: /dash or /responses to clear out legacy setters
        ].join('')
        window.location.href = currentUrl
    }

    public async mounted() {
        this.getFilters()
        this.getScorecardTopics()
        this.getDigests()
        this.statusClearToasts()

        const response = await getBaseUserRoles()

        if (response.success) {
            this.userRoles = response.data
        }

        /**
         * Any template data that is directly in the html
         * This can be removed later if this data is provided by an endpoint
         */
        const filterDataFromHtml = document.getElementById('filter-bar-v3-data')

        if (filterDataFromHtml) {
            this.showTV =
                filterDataFromHtml.getAttribute('data-show-tv') === '1'
            this.showButtons =
                filterDataFromHtml.getAttribute('data-show-buttons') === '1'
            this.enabledLeadWithAnyQuestion =
                filterDataFromHtml.getAttribute(
                    'data-has-lead-with-any-question'
                ) === '1'
            this.setAppBaseUrl(
                filterDataFromHtml.getAttribute('data-app-base-url')
            )
        }
    }
}
